import Box from "@material-ui/core/esm/Box";
import Paper from "@material-ui/core/esm/Paper";
import Face from "@material-ui/icons/esm/Face";
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import Business from "@material-ui/icons/esm/Business";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info, Subtitle, Title, BoldSubtitle } from 'components/Text';
import getCustomerName from 'utils/customers/getCustomerName';
import useStyles from '../CustomersStyle';
import CustomerSkeleton from './CustomerSkeleton';
export default function CustomerCards({
  loading,
  customers,
  isCompany = false,
  redirectToCustomer
}) {
  const {
    t
  } = useTranslation();
  const {
    customersCard,
    icon,
    box,
    chevron,
    customerNumberBox,
    breakAllText
  } = useStyles();
  const customerElements = customers?.map(customer => /*#__PURE__*/React.createElement(Paper, {
    variant: "outlined",
    className: customersCard,
    onClick: () => redirectToCustomer(customer),
    key: customer?.id
  }, isCompany ? /*#__PURE__*/React.createElement(Business, {
    className: icon
  }) : /*#__PURE__*/React.createElement(Face, {
    className: icon
  }), /*#__PURE__*/React.createElement(Box, {
    className: box
  }, /*#__PURE__*/React.createElement(BoldSubtitle, {
    align: "left"
  }, getCustomerName(customer, isCompany)), /*#__PURE__*/React.createElement(Box, {
    className: customerNumberBox
  }, /*#__PURE__*/React.createElement(Subtitle, {
    className: breakAllText,
    component: "h4"
  }, `${t('customers.customer_number')}:`), /*#__PURE__*/React.createElement(Subtitle, {
    className: breakAllText,
    component: "h4"
  }, customer.customerNumber))), /*#__PURE__*/React.createElement(ChevronRight, {
    className: chevron
  })));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Title, null, isCompany ? t('customers.business') : t('customers.private_person')), loading ? /*#__PURE__*/React.createElement(CustomerSkeleton, null) : customerElements, !loading && customerElements?.length === 0 && /*#__PURE__*/React.createElement(Info, null, isCompany ? t('customers.no_associated_business') : t('customers.no_private_persons_found')));
}
CustomerCards.defaultProps = {
  isCompany: false
};